"use client";

/**
 * @deprecated Use `ListPageShell` from `components/ui/v2/layout/page-shell`.
 */
export type { ListPageShellProps as MaintainerListPageV2Props } from "components/ui/v2/layout/page-shell";
export { ListPageShell as MaintainerListPageV2 } from "components/ui/v2/layout/page-shell";
